import React from 'react';
import { MdClose } from 'react-icons/md';
import '../YantraManage.css';
import { LIVE_YANTRA_IMAGE_URL } from '../../../utils/utils';

const EditYantraModal = ({
  isOpen,
  formData,
  handleChange,
  handleImageChange,
  handleSave,
  handleCancel,
  isSubmiting
}) => {
  if (!isOpen) return null;

  return (
    <div className="yantra_modal-overlay" onClick={handleCancel}>
      <div className="yantra_modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="yantra_modal-header">
          <h2>Edit Yantra</h2>
          <button className="yantra_modal-close" onClick={handleCancel}>
            <MdClose />
          </button>
        </div>
        <div className="yantra_modal-body">
          <div className="yantra_form-group">
            <label>Name</label>
            <input
              type="text"
              name="yantra_name"
              value={formData.yantra_name || ""}
              onChange={handleChange}
              placeholder="Yantra name"
            />
          </div>
          <div className="yantra_form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description || ""}
              onChange={handleChange}
              placeholder="Yantra description"
            />
          </div>
          <div className="yantra_form-group">
            <label>Yantra Image</label>
            <div className="image-upload-container">
              <input
                type="file"
                name="yantra_img"
                onChange={handleImageChange}
                accept="image/*"
                className="file-input"
              />
              {(formData.yantra_img_preview || formData.yantra_img) && (
                <img
                  src={
                    formData.yantra_img_preview ||
                    `${LIVE_YANTRA_IMAGE_URL}/${formData.yantra_img}`
                  }
                  alt="Preview"
                  className="image-preview"
                />
              )}
            </div>
          </div>
        </div>
        <div className="yantra_modal-footer">
          <button className="btn-save" onClick={handleSave} disabled={isSubmiting}>
            {isSubmiting ? 'Submitting...' : 'Save Changes'}
          </button>
          <button className="btn-cancel" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditYantraModal;